import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { __ } from '../../lib/i18n';
import './Product.scss';
import binSrc from '../../img/bin.svg';
import download from '../../img/download.svg';
import { ProductSkeleton } from '../ProductsSkeleton/ProductsSkeleton';

const Product = (props) => {
  const {
    lang,
    product: { id, title, images, price, currency, description, sold },
  } = props;

  const descriptionClassName = 'description mt-2 mb-1';
  const emptyDescription = !(description && description.length > 0);
  const descriptionClassNames = emptyDescription
    ? [descriptionClassName, 'empty-description'].join(' ')
    : descriptionClassName;
  const descriptionText = emptyDescription
    ? __(lang, 'EMPTY_PRODUCT_DESCRIPTION')
    : description;

  const handleClickDownload = (event) => {
    event.preventDefault();
    let finalURL = images[0].URL;

    const splitedFilename = images[0].filename.split('.');
    const fileExtension = splitedFilename[splitedFilename.length - 1];

    fetch(finalURL)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${title || 'download'}.${fileExtension}`;
        a.click();
        return a;
      });
  };
  const handleDelete = (event) => {
    event.preventDefault();
    const confirmed = window.confirm(__(lang, 'DELETE_PRODUCT_CONFIRM'));
    if (confirmed) {
      props.handleDelete(id);
    }
  };

  const handleEdit = (event) => {
    event.preventDefault();
    props.handleEdit(props.product);
  };
  const handleClickExtractions = (event) => {
    event.preventDefault();
    props.handleExtractions(props.product);
  };

  const [showSkeleton, setShowSkeleton] = useState(true);

  const onLoadImageSource = () => { setShowSkeleton(false) }

  return (
    <div style={{ position: 'relative' }}>
      {showSkeleton &&
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', width: '100%', height: '100%'
        }}>
          <ProductSkeleton />
        </div>}
      <div
        className={`Product mt-3 ${showSkeleton ? 'hiddenn' : 'fade-inn'}`}
        style={{ /* marginLeft: '-15px', marginRight: '-15px', */ visibility: showSkeleton ? 'hidden' : 'visible' }}>

        <div style={{ position: 'relative' }}>
          <img
            loading='lazy'
            id={id}
            className="rounded"
            src={images[0].thumbBigURL}
            alt={'...'}
            style={{
              width: '100%',
              objectFit: 'cover',
              aspectRatio: '9/9',
            }}
            onLoad={onLoadImageSource}
          />

          {sold && <div className="soldOut">{__(lang, "SOLD")}</div>}
          <div className="Product_options rounded">
            <button className="btn btn-download buttonBigWhenHover" onClick={handleClickDownload}>
              <img id="img-download" title='Download' src={download} alt={'...'} />
            </button>
            <button className="btn btn-bin buttonBigWhenHover" title='Delete' onClick={handleDelete}>
              <img id="img-bin" src={binSrc} alt={'...'} />
            </button>
            <button className="btn-image-action btn-edit buttonBigWhenHover" onClick={handleEdit}>
              {__(lang, 'EDIT')}
            </button>
            <button
              className="btn-image-action btn-extraction buttonBigWhenHover"
              style={{ marginRight: 0 }}
              onClick={handleClickExtractions}>
              {__(lang, 'EXTRACTION')}
            </button>
          </div>
        </div>
        <div className="ProductInfo clearfix" style={{ marginLeft: '15px' }}>
          <p className="h5 font-weight-bold mt-4 mb-3">
            {title !== null ? title : '-'}
          </p>
          <p className={descriptionClassNames}>{descriptionText}</p>
          <p className="mt-1">
            {currency}{' '}
            {price
              ? price.toLocaleString('es-ES', { minimumFractionDigits: 2 })
              : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

Product.propTypes = {
  lang: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleExtractions: PropTypes.func.isRequired,
};

export default Product;
